import { DlpSettingsService } from '@/services/api/dlpSettingsApiArea/DlpSettingsService';
import { DlpSettingsServiceType } from '@/services/api/dlpSettingsApiArea/interface';

/** Метод dlpSettingsApiArea возвращает экземпляр DlpSettingsService. По необходимости можно реализовать снгл тон. **/
export const dlpSettingsApiArea: { (): DlpSettingsServiceType } = () => new DlpSettingsService();
